(function($) {

    $(document).ready(function() {
        if (("#periodicals").length > 0) {
            $("#periodicals").addClass("periodicals");
            // setTimeout(function() {
            //     $(".cards-with-detail.periodicals .row-wrap").addClass("active show");
            // }, 300);


            if ((".cards-with-detail.periodicals .row-wrap .col-two").length > 7) {
                $(".cards-with-detail.periodicals .row-wrap .col-two").addClass("item");
                setTimeout(function() {
                    $(".cards-with-detail.periodicals .row-wrap .col-two:nth-child(1)").removeClass("item");
                    $(".cards-with-detail.periodicals .row-wrap .col-two:nth-child(2)").removeClass("item");
                    $(".cards-with-detail.periodicals .row-wrap .col-two:nth-child(3)").removeClass("item");
                    $(".cards-with-detail.periodicals .row-wrap .col-two:nth-child(4)").removeClass("item");
                    $(".cards-with-detail.periodicals .row-wrap .col-two:nth-child(5)").removeClass("item");
                    $(".cards-with-detail.periodicals .row-wrap .col-two:nth-child(6)").removeClass("item");
                }, 200);
                setTimeout(function() {
                    $(".cards-with-detail.periodicals .row-wrap .col-two.item").wrapAll('<div class="item-outer"></div>');
                }, 400);
            }

            $(document).on('click', '.cards-with-detail.periodicals .link-more span', function(e) {
                e.preventDefault();
                // $(".cards-with-detail .row-wrap").addClass("active");
                var className = $(this).text();
                if (className == "View More") {
                    $(this).text('Hide');
                    $(this).parent().addClass("expanded");
                    $(".cards-with-detail .row-wrap").removeClass("show");
                    $(".cards-with-detail.periodicals .row-wrap .item-outer").slideDown();
                } else {
                    $(this).text('View More');
                    $(".cards-with-detail .row-wrap").addClass("show");
                    $(this).parent().removeClass("expanded");
                    $(".cards-with-detail.periodicals .row-wrap .item-outer").slideUp();
                }
                // headerHeight = $(".cards-with-detail.periodicals").offset().top - $("header").outerHeight() - $(".sticky-nav").outerHeight();
                // $("html, body").animate({
                //         scrollTop: headerHeight,
                //     },
                //     600,
                //     "linear"
                // );
            });
        }
    });

    $(window).on('load', function() {
        if (("#periodicals").length > 0) {
            // $(".cards-with-detail .row-wrap").addClass("active show");
            setTimeout(function() {
                $.each($('.periodicals'), function() {
                    // var x = 6;
                    // var item = $(this).find('.col-two');
                    // var conLen = $(this).find('.col-two').length;
                    // if (conLen > 6) {
                    //     $(this).find('.link-more').show();
                    // } else $(this).find('.link-more').hide();

                    // item.slice(0, 6).show();



                });
            }, 200);
        }

        setTimeout(function() {
            $.each($('.js_inactive_research_team .cards-with-detail.news-detail'), function() {
                var x = 6;
                var item = $(this).find('.col-two');
                var conLen = $(this).find('.col-two').length;
                if (conLen > 6) {
                    $(this).find('.link-more').show();
                } 
                // else $(this).find('.link-more').hide();

                item.slice(0, 6).show();

                $(this).find('.link-more span').on('click', function(e) {
                    // $(".cards-with-detail .row-wrap").addClass("active");
                    e.preventDefault();
                    // x = conLen;
                    // if (!$(this).parent().hasClass("expanded")) {
                    //     item.slice(0, x).slideDown();
                    //     if (x >= conLen) {
                    //         $(this).parent().addClass("expanded");
                    //         $(".cards-with-detail .row-wrap").removeClass("show");
                    //         x = conLen;
                    //         setTimeout(function() {
                    //             $(".cards-with-detail.news-detail .link-more span").text('Hide');
                    //         }, 50);

                    //     }
                    // } else {
                    //     item.slice(6, x).slideUp();
                    //     $(this).parent().removeClass("expanded");
                    //     $(".cards-with-detail .row-wrap").addClass("show");
                    //     x = 6;
                    //     setTimeout(function() {
                    //         $(".cards-with-detail.news-detail .link-more span").text('View Inactive Research Programs');
                    //     }, 50);

                    // }
                    var btn = $(this);
                    var wrapper = btn.closest('.js_inactive_research_team');
                    var section = wrapper.find('.cards-with-detail.inactive');
                    var rowWrap = section.find('.row-wrap');

                    if (!btn.parent().hasClass("expanded")) {
                        btn.text('Hide');
                        btn.parent().addClass("expanded");
                        rowWrap.slideDown();
                    } else {
                        btn.text('View Inactive Research Programs');
                        btn.parent().removeClass("expanded");
                        rowWrap.slideUp();
                    }
                });

            });
        }, 200);
        // $('.cards-with-detail .col-two').matchHeight();
        $(".cards-with-detail .text-wrap h4").dotdotdot({
            height: 64,
            fallbackToLetter: true,
            watch: true,
        });

        // setTimeout(function() {
        //     var inactiveRowWrap = '.cards-with-detail.inactive .row-wrap';
        //     var moreBtn = '.cards-with-detail.inactive .btn-wrapper .link-more';
        //     var inactiveColTwo = $(inactiveRowWrap).find('.col-two');
        //     var inactiveColTwoLength = inactiveColTwo.length;
        //     if (inactiveColTwoLength > 0) {
        //         $(moreBtn).css('display', 'block');
        //         $(inactiveRowWrap).slideUp();
        //         $(moreBtn).find('span').on('click', function(e) {
        //             $(inactiveRowWrap).slideToggle();
        //         });
        //     }
        // }, 300);
    });
})(jQuery);